<script lang="ts">
    export let content: string
</script>

{#if content}
    <!--
        Die CSS-Klasse ".content-builder" diehnt als CSS-Namespace für alle Content-Builder Klassen,
        um sicherzustellen, dass "möglichst" keine Theme-Styles überschrieben werden.
    -->
    <main class="content-builder">
        {@html content.replace(/(["'])medialib\//g, "api/medialib/")}
    </main>
{/if}
